import { useCallback } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import { useLocale } from '../contexts/LocaleContext';
import { db } from '../config/firebase';
import { COLLECTIONS } from '../config/collections';
import type { AppLocale } from '../i18n/types';

/**
 * Change la locale UI immédiatement (localStorage via LocaleContext).
 * Persistance Firestore `preferredLocale` en arrière-plan — n’bloque pas l’UI
 * et ne rollback jamais le changement local en cas d’échec réseau / rules.
 */
export function useChangeAppLocale() {
  const { locale, setLocale } = useLocale();
  const { user, patchUserProfile } = useAuth();

  const changeLocale = useCallback(
    (next: AppLocale) => {
      if (next === locale) return;

      setLocale(next);

      if (!user) return;

      // Optimistic : évite que LocaleAuthSync réapplique l’ancienne langue
      patchUserProfile({ preferredLocale: next });
      void updateDoc(doc(db, COLLECTIONS.users, user.uid), {
        preferredLocale: next,
      }).catch((error) => {
        console.warn('Impossible de sauvegarder preferredLocale (UI conservée):', error);
      });
    },
    [locale, setLocale, user, patchUserProfile]
  );

  return { locale, changeLocale };
}
